<ng-container [formGroup]="form">
<input class="as-button {{class}}" (change)="updateModel($event)" [formControlName]="name" [value]="value" type="checkbox" [name]="name" [id]="name" [required]="required" [checked]="model == value">
<label class="radio" [for]="name"><i [class.twingle-checkbox-unchecked]="model != value" [class.twingle-checkbox-checked2]="model == value"></i><span [innerHTML]="label"></span></label>
</ng-container>
